module.exports = __webpack_public_path__ + "static/media/7.1835b26e.jpg";